Vue.component('nodo-multimedia', {
  name: 'nodo-multimedia',
  props: ['currentmedia'],
  template: '<div v-if="isActive">' +
    '<div class="swiper-container nodo-multimedia" v-bind:id="currentID">' +
    '<div class="swiper-wrapper">' +
    '<div class="swiper-slide" v-for="(item,index) in mediaObject.media_objects" :class="mediaObject.media_type">' +
    '<div class="row" @click="openExternalLink(item.button_url)">' +
    '<audio v-if="mediaObject.media_type == \'audio\'" class="player" :src="item.media_url" preload controls></audio>' +
    '<video v-if="mediaObject.media_type == \'video\'" class="player" :src="item.media_url" preload controls></video>' +
    '<div v-if="mediaObject.media_type == \'image\'" class="thumb" :style="getUrlBgImg(item.media_url)"><a v-if="hasImgLink(item.media_url)" :style="getHeightImg()" :href="item.media_url | checkIfImgBase64" target="_blank"></a></div>' +
    '<div v-if="mediaObject.media_type == \'link\'"  ></div>' +
    '<div v-if="item.button_url" class="external-link">' +
    '<h3 class="text-left" v-html="truncateFunction(item.title)"></h3>' +
    '<div class="txt text-left" v-if="item.caption"> {{ item.caption | truncateCaption }}</div>' +
    '<button v-if="item.button_url" class="btn btn-media" :href="item.button_url" target="_blank" ><a v-html="item.button_title"></a></button>' +
    '</div>' +
    '<div v-else>' +
    '<h3 class="text-left" v-html="truncateFunction(item.title)"></h3>' +
    '<div class="txt text-left" v-if="item.caption"> {{ item.caption | truncateCaption }}</div>' +
    '<button v-if="item.button_url" class="btn btn-media" :href="item.button_url" target="_blank" ><a v-html="item.button_title"></a></button>' +
    '</div>' +
    '<div v-else="item.button_url" class="space-btn"></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div class="swiper-pagination" v-if="pagination"></div>' +
    '<div class="swiper-button-next" v-if="swipeNext"></div>' +
    '<div class="swiper-button-prev" v-if="swipePrev"></div>' +
    '</div>' +
    '</div>',
  data: function() {
    return {
      isActive: true,
      prepend: false,
      nodoComplete: false,
      currentID: null,
      truncateCharacterTitle: 35,
      truncateCharacterCaption: 94,
      pagination: true,
      swipeNext: true,
      swipePrev: true,
      mediaUrl: null,
      typeAudio: false,
      typeVideo: false,
      typeImg: false,
      typeLink: false,
      title: '',
      caption: '',
      buttonUrl: '',
      buttonTitle: '',
      mediaType: '',
      nodoMultimedia: null,
      mediaObject: null,
      oneItem: false,
      heightImg: 100,
      optionSliderMultimedia: {
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 5,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        breakpoints: {
          // when window width is <= 320px
          420: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          // when window width is <= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1600: {
            slidesPerView: 3,
            spaceBetween: 20
          },
        }
      }



    }
  },
  created: function() {
    this.build();
    this.checkElement()
  },
  mounted: function() {
    this.$nextTick(function() {
      var elId = "#" + this.currentID;
      if (!this.oneItem) { // if more item init swiper
        var swiper = new Swiper(elId, this.optionSliderMultimedia)
      }
    })
  },
  filters: {
    truncateTitle: function(value) {
      var text = value;
      if (value.length > this.truncateCharacterTitle) {
        text = text.substr(0, this.truncateCharacterTitle - 3) + "...";
      }
      return text;
    },
    truncateCaption: function(value) {
      var text = value;
      if (value.length > this.truncateCharacterCaption) {
        text = text.substr(0, this.truncateCharacterCaption - 3) + "...";
      }

      return text;
    },
    checkIfImgBase64: function(img) {
      if (img.indexOf("base64") != -1) {
        return false;
      }
      return img;
    }
  },
  methods: {
    truncateFunction: function(value){
      return this.$options.filters.truncateTitle(value);
    },
    hasImgLink: function(img) {
      if (img) {
        if (img.indexOf("base64") != -1) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    getNodo: function() {
      return this.nodoMultimedia.media
    },
    lenNodo: function() {
      return this.getNodo().length;
    },
    getUrlBgImg: function(url) {
      return { 'background-image': 'url("' + url + '")' }
    },
    getHeightImg: function(url) {
      return { 'height': this.heightImg + 'px' }
    },
    checkElement: function(item) {
      if (this.currentmedia.msg.media.media_objects.length == 1) {
        this.oneItem = true;
        this.resetSlider();
      }
    },
    openExternalLink: function(link) {
      window.open(link, '_blank');
    },
    resetSlider: function() {
      this.pagination = false;
      this.swipeNext = false;
      this.swipePrev = false;
      this.optionSliderMultimedia.slidesPerView = 1;
      this.optionSliderMultimedia.breakpoints = {
        // when window width is <= 320px
        420: {
          slidesPerView: 1
        },
        // when window width is <= 640px
        640: {
          slidesPerView: 1
        },
        1600: {
          slidesPerView: 1
        },
      }
    },
    build: function() {
      this.nodoMultimedia = this.currentmedia.msg;
      this.currentID = Date.now();
      this.mediaObject = this.currentmedia.msg.media;
    },
    getId: function() {
      return this.currentID;
    },

  }
})
